import { AcceptedTrackersType } from '../../../../front/doctrine/cookies/cookies.types';
import {
  fullstoryTracker,
  facebookTracker,
  linkedinTracker,
  twitterTracker,
  googleAnalytics,
} from './trackers';

export const setTrackerFunctions = () => {
  // To make it work with the current system
  window.fetchFullstory = fullstoryTracker;
  window.fetchFacebook = facebookTracker;
  window.fetchLinkedin = linkedinTracker;
  window.fetchTwitter = twitterTracker;
};

export const activateTrackers = async (
  acceptedTrackers: AcceptedTrackersType | null,
) => {
  if (!acceptedTrackers) {
    return;
  }
  if (acceptedTrackers.twitter_cookie) {
    twitterTracker();
  }
  if (acceptedTrackers.facebook_retargeting_cookie) {
    facebookTracker();
  }
  if (acceptedTrackers.accepted) {
    await fullstoryTracker();
    linkedinTracker();
  }
  if (!acceptedTrackers.accepted || acceptedTrackers.ga_cookie) {
    googleAnalytics(acceptedTrackers.accepted, acceptedTrackers.ga_cookie);
  }
};
